import { onReady } from './lib/dom.js';
import { initLoading } from './modules/loading.js';
import { initMenu } from './modules/menu.js';
import { initFixedSns } from './modules/fixed-sns.js';
import { initMembers } from './modules/members.js';
import { initReveal } from './modules/reveal.js';

onReady(() => {
  document.documentElement.dataset.budokanReady = 'true';
  initReveal();
  initLoading();
  initMenu();
  initFixedSns();
  initMembers();
});
